namespace GeniuzPOS.Product {
    export interface CsBrandForm {
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
    }

    export class CsBrandForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsBrand';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsBrandForm.init)  {
                CsBrandForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsBrandForm, [
                    'BrandCode', w0,
                    'BrandName', w0
                ]);
            }
        }
    }
}
